/**
 * Consultations API: list consultants, my bookings, book consultation.
 */
import { apiGet, apiPost } from '../../../shared/api/client';
import { endpoints } from '../../../shared/config/endpoints';
import type { ConsultantsResponse, MyConsultationsResponse, ConsultantApi, MyConsultationBooking } from './apiTypes';

export async function fetchConsultants(customer_id: number, date: string): Promise<ConsultantApi[]> {
  const res = await apiGet<ConsultantsResponse>(endpoints.consultants, { customer_id, date });
  const list = res?.data?.consultants;
  return Array.isArray(list) ? list : [];
}

export async function fetchMyConsultations(customer_id: number): Promise<MyConsultationBooking[]> {
  const res = await apiGet<MyConsultationsResponse>(endpoints.consultations, { customer_id });
  const list = res?.data?.consultations;
  return Array.isArray(list) ? list : [];
}

export interface BookConsultationPayload {
  customer_id: number;
  consultant_id: number;
  date: string;
  time_slot: string;
  notes?: string;
}

export async function bookConsultation(payload: BookConsultationPayload): Promise<unknown> {
  const res = await apiPost<unknown>(endpoints.bookConsultants, payload);
  return res;
}
